import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import SmallHelpText from './SmallHelpText';

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SavableFormLabel(props) {
  const [showResult, setShowResult] = useState(true);
  const [failed, setFailed] = useState(true);
  useEffect(() => {
    if (props.isSaving) {
      setShowResult(false);
      setFailed(false);
      return () => {};
    } else {
      const resultTimeout = setTimeout(() => setShowResult(true), 100);
      const failedTimeout = setTimeout(() => setFailed(true), 2000);
      return () => {
        clearTimeout(resultTimeout);
        clearTimeout(failedTimeout);
      };
    }
  }, [props.isSaving]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    direction: "row",
    justify: "start",
    wrap: "wrap",
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        className: props.helpLangPath ? 'm-all-0 p-all-0' : undefined,
        "data-test-id": "form-label-test-id",
        htmlFor: props.htmlFor,
        required: props.isRequired,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "label-message",
          message: props.labelLangPath
        })
      }), props.helpLangPath ? /*#__PURE__*/_jsx("div", {
        className: "m-bottom-1",
        children: /*#__PURE__*/_jsx(SmallHelpText, {
          "data-test-id": "help-text",
          textLangPath: props.helpLangPath
        })
      }) : null]
    }), /*#__PURE__*/_jsx(UIFlex, {
      align: "center",
      className: props.helpLangPath ? 'm-bottom-8' : 'm-bottom-1',
      direction: "row",
      justify: "end",
      wrap: "wrap",
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {
        className: "savable-label-loading-spinner",
        "data-test-id": "loading-spinner-test-id",
        failed: failed,
        showResult: showResult,
        size: "xs"
      })
    })]
  });
}
SavableFormLabel.propTypes = {
  helpLangPath: PropTypes.string,
  htmlFor: PropTypes.string,
  isRequired: PropTypes.bool,
  isSaving: PropTypes.bool,
  labelLangPath: PropTypes.string.isRequired
};
SavableFormLabel.defaultProps = {
  helpLangPath: '',
  htmlFor: undefined,
  isRequired: false,
  isSaving: false
};
export default SavableFormLabel;